import { canAccess } from '../../authorization/canAccess';
import { resolveItemAccess } from '../../config/authorization/menuAccess';

/**
 * @param {import('../../config/navigation/navigation.constants.js').NavLeaf[]} [items]
 * @param {import('../../authorization/types/authz.types').AuthzContext} authz
 * @param {import('../../authorization/types/authz.types').AuthzRequirement} [parentAccess]
 */
function filterNavTree(items = [], authz, parentAccess = null) {
  if (!items.length) return [];

  return items.reduce((visible, item) => {
    if (!item) return visible;

    const itemAccess = resolveItemAccess(item, parentAccess);
    const effectiveAccess = itemAccess || parentAccess;
    const filteredChildren = item.children?.length
      ? filterNavTree(item.children, authz, effectiveAccess)
      : [];

    const hasRoute = Boolean(item.route);
    const selfVisible = item.key === 'dashboard' || canAccess(authz, itemAccess);
    const groupVisible = !hasRoute && !item.children?.length
      ? selfVisible
      : selfVisible || filteredChildren.length > 0;

    if (!groupVisible) {
      return visible;
    }

    visible.push({
      ...item,
      ...(item.children ? { children: filteredChildren } : {}),
    });
    return visible;
  }, []);
}

/**
 * @param {import('../../config/navigation/navigation.constants.js').NavSection[]} sections
 * @param {import('../../authorization/types/authz.types').AuthzContext} [authz]
 */
export function filterNavigation(sections, authz) {
  if (!authz?.isAuthzV2Enabled || authz?.isFullAccess) {
    return sections
      .map((section) => ({
        ...section,
        items: (section.items || []).filter(Boolean),
      }))
      .filter((section) => section.items.length > 0);
  }

  return sections
    .map((section) => ({
      ...section,
      items: filterNavTree(section.items || [], authz),
    }))
    .filter((section) => section.items.length > 0);
}

/**
 * @param {import('../../config/navigation/navigation.constants.js').NavLeaf[]} [items]
 * @param {import('../../authorization/types/authz.types').AuthzContext} [authz]
 */
export function filterNavItems(items = [], authz) {
  if (!authz?.isAuthzV2Enabled || authz?.isFullAccess) {
    return items.filter(Boolean);
  }
  return filterNavTree(items, authz);
}
